import FieldEditorGallery from "editor/FieldEditorGallery";
import FieldEditorSingleImage from "editor/FieldEditorSingleImage";
import FieldEditor from "editor/FieldEditor";

import "video/YoutubeVideo";
import "video/VimeoVideo";
import "editor/FieldEditorVideo";

FieldEditor.register_editor('gallery', FieldEditorGallery);
FieldEditor.register_editor('gallery/single', FieldEditorSingleImage);
